export const SET_USER_INFO = 'setUserInfo'
export const SET_USER_IS_LOGGED_IN = 'setUserIsLoggedIn'
export const SET_JWT = 'setJWT'



// WEBPACK FOOTER //
// ./src/store/module/auth/mutationTypes.js